import React, { Component } from "react";
import { toast } from "react-toastify";
// datatable
import "jquery/dist/jquery.min.js";

import "datatables.net-dt/js/dataTables.dataTables";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import Button from "@mui/material/Button";

import { Col, Modal, Row } from "react-bootstrap";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import PreviewIcon from "@mui/icons-material/Preview";

import logo from "../../images/logo.png";

//API handling components
import { API_URL } from "../../Global";

// picker
import TextField from "@mui/material/TextField";

//
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

// datatable
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs4");
require("datatables.net-autofill-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-buttons/js/buttons.colVis");
require("datatables.net-buttons/js/buttons.flash");
require("datatables.net-buttons/js/buttons.html5");
require("datatables.net-buttons/js/buttons.print");
require("datatables.net-responsive-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("pdfmake");

const axios = require("axios");

export class QuoteHistory extends Component {
    constructor(props) {
        super();

        this.state = {
            showUpdateModel: false,
            currentQuotId: null,
            quotList: [],
            itemsList: null,
            printComponentRef: null,
            startingDate: "2021-12-01",
            endingDate: "2021-12-23",
        };
    }

    fetchQuotList = () => {
        let url = API_URL;
        const query = `SELECT * FROM quotation as q where q.status=1 ORDER BY q.id DESC;`;
        // const query = `SELECT * FROM quotation  where  status=1  and date between "${this.state.startingDate}" and "${this.state.endingDate} "ORDER BY id DESC ;`;

        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                console.log("bill: ", res.data);
                this.setState({ quotList: res.data });

                // init data table
                this.initializeDataTable();
            })
            .catch((err) => {
                console.log("Quot list fetch error: ", err);
            });
    };

    refetchQuotList = (e) => {
        let url = API_URL;
        const query = `SELECT * FROM quotation as q where q.status=1 and date between '${this.state.startingDate}' and '${this.state.endingDate}' ORDER BY q.id DESC;`;
        // const query = `SELECT * FROM quotation  where  status=1  and date between "${this.state.startingDate}" and "${this.state.endingDate} "ORDER BY id DESC ;`;
        console.log(query);
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                console.log("bill: ", res.data);
                this.setState({ quotList: res.data }, this.refresh);

                //     // init data table
            })
            .catch((err) => {
                console.log("Quot list fetch error: ", err);
            });
    };

    fetchQuotItemList = () => {
        let url = API_URL;
        const query = `SELECT * FROM billList where billId = ${this.state.currentQuotId} and billType=3;`;
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                console.log("bill list data: ", res.data);
                this.setState({ itemsList: res.data });

                // init data table
                this.initializeDataTable();
            })
            .catch((err) => {
                console.log("bill list fetch error: ", err);
            });
    };

    deleteRecord(id) {
        let url = API_URL;
        const query = `UPDATE quotation SET status = 0  WHERE id=${id};`;
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                console.log("deleted status data: ", res.data);
                toast.success("Record deleted successfully");
                this.fetchQuotList();
                this.refresh();
            })
            .catch((err) => {
                console.log("record delete error: ", err);
                toast.error("Failed to delete record");
            });
    }

    initializeDataTable() {
        $("#quotHistoryTable")
            .DataTable({
                destroy: true,
                dom:
                    "<'row mb-2'<'col-sm-9' B><'col-sm-3' >>" +
                    "<'row mb-2'<'col-sm-9' l><'col-sm-3' f>>" +
                    "<'row'<'col-sm-12' tr>>" +
                    "<'row'<'col-sm-7 mt-2 mr-5 pr-4'i><'ml-5' p>>",
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ["csv", "print"],
                order: [[0, "desc"]],
            })
            .buttons()
            .container();
    }

    componentDidMount() {
        this.fetchQuotList();
    }

    refresh() {
        window.location.reload(false);
    }

    renderQuotList = () => {
        if (this.state.quotList == null || this.state.quotList.length == 0)
            return null;

        // else
        return this.state.quotList.map((quot) => {
            return (
                <>
                    <tr align="center">
                        <td>{quot.id}</td>
                        <td>
                            {quot.companyType == 1 ? "Imprint 24" : "Sign Mart"}
                        </td>
                        <td>{quot.partyName}</td>
                        <td>{quot.address}</td>
                        <td>{quot.mobileNo}</td>
                        <td>{quot.total}</td>
                        <td>{moment(quot.date).format("DD/MM/YYYY")}</td>
                        <td className="d-flex justify-content-center">
                            &nbsp;
                            <PreviewIcon
                                className="CPointer"
                                onClick={() => {
                                    this.setState(
                                        {
                                            showUpdateModel: true,
                                            currentQuotId: quot.id,
                                            quotNumber: quot.quotNumber,
                                            name: quot.partyName,
                                            address: quot.address,
                                            mobileNo: quot.mobileNo,
                                            total: quot.total,
                                            date: quot.date,
                                        },
                                        this.fetchQuotItemList
                                    );
                                }}
                                color="success"
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <DeleteIcon
                                className="CPointer"
                                onClick={(e) => {
                                    if (window.confirm("Delete the item?")) {
                                        this.deleteRecord(quot.id);
                                    }
                                }}
                                color="error"
                            />
                        </td>
                    </tr>
                </>
            );
        });
    };

    render() {
        return (
            <div className="my-4">
                <TextField
                    id="startingDate"
                    // label="startingDate"
                    variant="outlined"
                    format="MM/DD/YYY"
                    className="mr-2"
                    value={this.state.startingDate}
                    onChange={(e) =>
                        this.setState({ startingDate: e.target.value })
                    }
                    // required="true"
                    size="small"
                    type="date"
                    style={{ width: "180px" }}
                />

                <TextField
                    id="endingDate"
                    // label="endingDate"
                    format="MM/DD/YYY"
                    variant="outlined"
                    className="mr-2"
                    value={this.state.endingDate}
                    onChange={(e) =>
                        this.setState({ endingDate: e.target.value })
                    }
                    // required="true"
                    size="small"
                    type="date"
                    style={{ width: "180px" }}
                />

                <Button
                    color="primary"
                    variant="contained"
                    className="mt-1 mr-1 mb-3 ml-5"
                    // onClick={this.refetchQuotList}
                >
                    <FontAwesomeIcon icon={faSyncAlt} size="2x" />
                </Button>
                <div>
                    <Row>
                        <Col
                            md="12"
                            className="m-0 p-1 measure1 table-responsive-md"
                            style={{ minHeight: "85vh" }}
                        >
                            <div>
                                <table
                                    id="quotHistoryTable"
                                    style={{ width: "100%" }}
                                >
                                    <thead>
                                        <tr align="center">
                                            <th align="center">Quot Ids</th>
                                            <th align="center">Company</th>
                                            <th align="center">Name</th>
                                            <th align="center">Address</th>
                                            <th align="center">Mobile No.</th>
                                            <th align="center">Total</th>
                                            <th align="center">Date</th>
                                            <th align="center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>{this.renderQuotList()}</tbody>
                                </table>
                                <Modal
                                    onHide={(e) =>
                                        this.setState({
                                            showUpdateModel: false,
                                        })
                                    }
                                    size="lg"
                                    show={this.state.showUpdateModel}
                                    // onHide={() => setLgShow(false)}
                                    aria-labelledby="example-modal-sizes-title-lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Bill Details</Modal.Title>
                                    </Modal.Header>
                                    <Row>
                                        {/* Overview */}

                                        <div
                                            className="ReceptContainerss"
                                            //   ref={(el) => setPrintComponentRef(el)}
                                            ref={(el) =>
                                                (this.printComponentRef = el)
                                            }
                                        >
                                            <div className="text-center">
                                                <div className="header  ReceptBg ">
                                                    <div className="row logoContainer">
                                                        <div className="col-6 text-start">
                                                            <img
                                                                src={logo}
                                                                alt="logo"
                                                                className="img-fluid"
                                                            />
                                                        </div>

                                                        <div className="col-6">
                                                            <p className="py-3 pl-4 text-start">
                                                                Shop No.2,
                                                                vithoba Complex,
                                                                Sangli-Miraj
                                                                Road <br />{" "}
                                                                Nr.Parshwanthnagar
                                                                Bus Stop, Miraj
                                                                - 416 410 (Maha){" "}
                                                                <br /> Mobile:
                                                                7293242424,
                                                                e-mail:
                                                                imprint24.india@gmail.com
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h5 className="bg-secondary text-white px-2">
                                                    QUOTATION
                                                </h5>

                                                <div className="p-2 text-start">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <p className="text-start">
                                                                Party Name:
                                                                &nbsp;{" "}
                                                                {
                                                                    this.state
                                                                        .name
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className="col-6">
                                                            <p>
                                                                {" "}
                                                                Phone No: &nbsp;
                                                                {
                                                                    this.state
                                                                        .mobileNo
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <p>
                                                                Address: &nbsp;{" "}
                                                                {
                                                                    this.state
                                                                        .address
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className="col-6">
                                                            <p>
                                                                Date :
                                                                {moment(
                                                                    this.state
                                                                        .date
                                                                ).format(
                                                                    "D/M/YYYY"
                                                                )}
                                                                {/* <b>
                                                                {moment(
                                                                    new Date()
                                                                ).format(
                                                                    "D/M/YYYY"
                                                                )}
                                                            </b> */}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <p>
                                                                Quot Number :
                                                                &nbsp;{" "}
                                                                {
                                                                    this.state
                                                                        .quotNumber
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <h6 className="bg-secondary text-secondary px-2">
                                                    .
                                                </h6>

                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Sr. No.</th>
                                                            <th>Product</th>
                                                            <th>Quantity</th>
                                                            <th>Sq. ft.</th>
                                                            <th>Unit</th>
                                                            <th>
                                                                Rate / sq.ft.
                                                            </th>
                                                            <th>Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.itemsList &&
                                                            this.state.itemsList.map(
                                                                (item, id) => {
                                                                    return (
                                                                        <tr
                                                                            key={
                                                                                id
                                                                            }
                                                                        >
                                                                            <td>
                                                                                {id +
                                                                                    1}
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    item.particular
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    item.quantity
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {item.width +
                                                                                    " X " +
                                                                                    item.height}
                                                                            </td>
                                                                            <td>
                                                                                Sq.
                                                                                ft.
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    item.rate
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {Number(
                                                                                    item.amount
                                                                                ).toFixed(
                                                                                    2
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        <tr>
                                                            <td colSpan={6}>
                                                                <b>
                                                                    Grand Total
                                                                </b>
                                                            </td>
                                                            <td>
                                                                <b>
                                                                    {this.state
                                                                        .total &&
                                                                        this.state.total.toFixed(
                                                                            2
                                                                        )}
                                                                </b>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <hr />
                                                <div className="row">
                                                    <div className="col-4 col-md-4">
                                                        <h6
                                                            style={{
                                                                textTransform:
                                                                    "capitalize",
                                                            }}
                                                        >
                                                            GST No.:{" "}
                                                            <b>
                                                                27EMNPP2479H1ZD
                                                            </b>
                                                        </h6>
                                                    </div>
                                                    <div className="col-6 col-md-4">
                                                        <img
                                                            src="/Assets/QrCode1.jpg"
                                                            height="100"
                                                            width="100"
                                                        />
                                                    </div>
                                                    <div className="col-4 col-md-4"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <ReactToPrint
                                                content={() =>
                                                    this.printComponentRef
                                                }
                                            >
                                                <PrintContextConsumer>
                                                    {({ handlePrint }) => (
                                                        <Button
                                                            onClick={
                                                                handlePrint
                                                            }
                                                            className="mb-5 mt-3 mr-3"
                                                            color="primary"
                                                            variant="contained"
                                                            style={{
                                                                float: "right",
                                                                marginRight:
                                                                    "40px",
                                                            }}
                                                            // disabled={saveFlag == true ? false : true}
                                                            // disabled={
                                                            //         (this.state.particular ||
                                                            //             this.state.quantity)
                                                            //             ? false
                                                            //             : true
                                                            //     }
                                                        >
                                                            PRINT
                                                        </Button>
                                                    )}
                                                </PrintContextConsumer>
                                            </ReactToPrint>
                                        </div>
                                        {/* invoice */}
                                    </Row>
                                </Modal>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default QuoteHistory;
